import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-smash-switch-on-off',
  templateUrl: './smash-switch-on-off.component.html',
  styleUrls: ['./smash-switch-on-off.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SmashSwitchOnOffComponent),
      multi: true
    }
  ]
})
export class SmashSwitchOnOffComponent implements ControlValueAccessor {

  @Input('disabled') disabled: any;
  @Input('value') _value: boolean = false;


  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();

  onChange: any = () => { };
  onTouch: any = () => { };

  constructor() { }

  writeValue(value: boolean): void {
    this.value = value;
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched(fn) {
    this.onTouch = fn;
  }

  set value(val) {
    this._value = val;
    this.onChange(val);
    this.onTouch(val);
    this.valueChange.emit(val);
  }

  get value(): boolean {
    return this._value;
  }

}
